import { ApolloClient } from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { HttpLink } from "apollo-link-http"
import { ApolloLink, from } from "apollo-link"
import fetch from "unfetch"
import {
  API_URL,
  APP_ID,
  // COMPANY_ID
} from "./constants"
// import { inBrowser } from "../utils/utils"
import { getDeviceId, inBrowser } from "@omnichannel/ace-b2b-elements"
import { getCompanyId } from '../utils/utils'

let deviceId = undefined
if (inBrowser) {
  getDeviceId().then(result => {
    deviceId = result
  })
}

const appMiddleware = new ApolloLink((operation, forward) => {
  let bearerAccessToken = "x"
  const accessToken = (inBrowser && localStorage.getItem("access-token")) || ""
  if (accessToken.length) {
    bearerAccessToken = `Bearer ${accessToken}`
  }

  const branch = JSON.parse(
    (inBrowser && localStorage.getItem("ace_app_branch")) || "{}"
  )
  let branchId = branch._id

  operation.setContext(({ headers = {} }) => {
    headers = {
      ...headers,
      appid: APP_ID,
      companyId: "5971c431b06bfa0a90c7c3a9", //SPV: ace companyId will this change ?
      deviceId,
      ...(branchId ? { branchId } : {}),
      // Authorization: bearerAccessToken,
    }
    return { headers }
  })
  return forward(operation)
})

const httpLink = new HttpLink({
  uri: `${API_URL}/seeall/graphql `,
  fetch,
})

const seeAllClient = new ApolloClient({
  cache: inBrowser
    ? new InMemoryCache().restore(window.__APOLLO_STATE__)
    : new InMemoryCache(),
  link: from([appMiddleware, httpLink]),
})

export default seeAllClient
